import LivedigitalSDKError from './LivedigitalSDKError';

class AlreadyCreatedError extends LivedigitalSDKError {
  static readonly DEFAULT_MESSAGE = 'Resource has already been created';

  constructor(msg?: string, errorCode?: string, meta?: Record<string, unknown>) {
    super(msg ?? AlreadyCreatedError.DEFAULT_MESSAGE, errorCode ?? 'already_created', meta);
  }
}

export default AlreadyCreatedError;
